import { DEFAULT_LOG_LEVEL, LOG_LEVEL, type LogLevel } from '../config';

let currentLevel: LogLevel = DEFAULT_LOG_LEVEL;

const isLevelEnabled = (level: LogLevel) => level >= currentLevel;

const setLogLevel = (level: LogLevel) => {
  currentLevel = level;
};

const getLogLevel = () => currentLevel;

const { debug, info, warn, error } = console;

export const logger = {
  debug: (...args: unknown[]) => {
    if (isLevelEnabled(LOG_LEVEL.DEBUG)) {
      debug(...args);
    }
  },
  info: (...args: unknown[]) => {
    if (isLevelEnabled(LOG_LEVEL.INFO)) {
      info(...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (isLevelEnabled(LOG_LEVEL.WARN)) {
      warn(...args);
    }
  },
  error: (...args: unknown[]) => {
    if (isLevelEnabled(LOG_LEVEL.ERROR)) {
      error(...args);
    }
  },
  isDebugEnabled: () => isLevelEnabled(LOG_LEVEL.DEBUG),
  setLogLevel,
  getLogLevel,
};
